module.exports = __webpack_public_path__ + "img/more.2ffa5a61.png";